import { QuantitySizes } from '@westondev/tableturn-core';

export const quantityModeConversion = {
  [QuantitySizes.LIGHT]: 0,
  [QuantitySizes.REGULAR]: 1,
  [QuantitySizes.EXTRA]: 2,
};
